import {
	TileInteractionMode,
	TileInteractionModeContextProvider,
} from 'app/src/editor/TileInteractionModeContext';
import Tile from 'app/src/engine/tiles/Tile';
import * as key from 'keymaster';
import * as React from 'react';

type Props = {
	children: React.ReactNode;
};

export default function TileInteractionModeController({ children }: Props): React.ReactElement {
	const [mode, setMode] = React.useState<TileInteractionMode>(TileInteractionMode.Wall);
	const [tile, setTile] = React.useState<Tile | null>(null);

	// Bind key handlers.
	React.useEffect(() => {
		key('r', () => {
			setMode(TileInteractionMode.Rotate);
		});
		key('c', () => {
			setMode(TileInteractionMode.Copy);
		});
		key('o', () => {
			setMode(TileInteractionMode.Robot);
		});
		key('w', () => {
			setMode(TileInteractionMode.Wall);
		});
		key('s', () => {
			setMode(TileInteractionMode.Star);
		});

		return (): void => {
			key.unbind('r');
			key.unbind('c');
			key.unbind('o');
			key.unbind('w');
			key.unbind('s');
		};
	}, []);

	return (
		<TileInteractionModeContextProvider
			value={{
				mode,
				setMode,
				tile,
				setTile,
			}}
		>
			{children}
		</TileInteractionModeContextProvider>
	);
}
